const buttonText = {
    login: "Avanzar",
    processing: "Procesando...",
    filter: "Filtrar",
    save_preferences: "Guardar preferencias",
    loading: "Cargando...",
    preferences: "Preferencias",
    loading_users: "Cargando usuarios...",
    logout: "Cerrar sesión",
}

const labelText = {
    email: "Correo electrónico",
    password: "Contraseña",
    nationality: "Nacionalidad",
    state: "Estado",
    city: "Ciudad",
    filters: "Filtro",
    search_name_therapist: "Busca por el nombre de tu terapeuta",
    search_name_therapist_placeholder: "Introduce el nombre",
    conduct_code_description: "Declaro que he leído y acepto todos los términos del",
    conduct_code_link: "Código de Conducta",
    mark_as_available: "Marque como habilitado si está disponible para atender.",
    availability: "Escriba abajo su disponibilidad. Ejemplo: Estoy disponible de lunes a viernes de 14 h a 16 h. Siéntase libre de incluir también datos de contacto, como correo o WhatsApp distinto de su predeterminado.",
    previous_page: "< Anterior",
    next_page: "Siguiente >",
}

const nacionalityDefaultOptions = [
    { value: 0, label: "Brasil" },
    { value: 1, label: "Otros países" },
]

const stateDefaultOptions = [
    { value: "", label: "Todos" },
]

const cityDefaultOptions = [
    { value: "", label: "Todas" },
]

const placeholderText = {
    email: "Escribe el correo electrónico.",
    password: "Ingrese su contraseña",
    nationality: "Nacionalidad",
}

const errorMessageText = {
    default: "No se pudo realizar la solicitud; por favor verifique que todos los campos estén correctamente completos. Si el problema persiste, contáctenos.",
    email: "Ingrese su correo electrónico.",
    password: "Ingrese su contraseña.",
    global: "Correo electrónico o contraseña inválidos, verifique lo ingresado.",
    is_internship_accepted_terms: "Para utilizar el sistema de ángeles y tutelados, debe aceptar los términos del código de conducta.",
    internship_availability: "Especifique su disponibilidad: Ej.: Disponible los lunes y miércoles por la noche.",
    save_info_global: "No pudimos guardar su información, inténtelo nuevamente.",
    update_info_global: "No pudimos actualizar su información, inténtelo nuevamente.",
    update_global: "No pudimos actualizar su información.",
    page_not_found: "Página no encontrada.",
    error_title: "Correo inválido",
}

const altText = {
    top_bar: "Ícono que representa el Instituto Brasileño",
}

const pageHomeText = {
    top_bar_content: "IBFT — Instituto Brasileño de Formación de Terapeutas",
    card_title: "Lista de Ángeles y Tutelados",
    card_text: "En la lista abajo, encontrará a todas las personas disponibles para atención e intercambio de experiencias de práctica. Haga clic en el nombre de la persona para obtener más detalles.",
    users_not_found: "No se encontró ningún usuario. Verifique sus preferencias y filtros arriba.",
    accordion_title_1: "Teléfono/WhatsApp:",
    accordion_title_2: "Correo electrónico:",
    accordion_title_3: "Disponibilidad:",
    greeting_prefix: "Hola,",
}

const modalPreferencesTherapistText = {
    modal_title: "Sus preferencias",
    how_to_be_angel: "Para ser Ángel o Tutelado es necesario contar con el certificado provisorio. Elija su Ángel en la lista y comuníquese por privado.",
    to_be_a_ward: "Si su objetivo es ser un tutelado, solo necesita aceptar el código de conducta. No debe marcar que está disponible para atender.",
    modal_mark_as_available: "Marque como habilitado abajo si está en condiciones de atender.",
}

const pageLoginText = {
    top_bar_content: "IBFT — Ángeles y Tutelados",
    card_title: "Bienvenido(a) a",
    card_title_black: "Ángeles y Tutelados!",
    card_text: "Para continuar, inicia sesión con el mismo correo electrónico que utilizas para acceder a tu curso en Apolo",
    confirm_code: "Confirmar Código",
    resend_code: "Reenviar Código",
    confirm_code_description: "Por favor, ingresa el código enviado al correo:",
    resend: "Reenviar",
    confirming: "Confirmando...",
    resending: "Reenviar...",
    confirm_code_title: "Confirma tu correo electrónico",
    invalid_code: "Código inválido",
}

const pageTherapistsText = {
    top_bar_content: "IBFT — Lista de Terapeutas",
    card_title: "Lista de Terapeutas",
    card_text: "En la lista abajo, encontrará a todos los terapeutas disponibles para atención e intercambio de experiencias de práctica. Haga clic en el nombre del terapeuta para obtener más detalles.",
    therapists_not_found: "No se encontró ningún terapeuta. Verifique sus preferencias y filtros arriba.",
    accordion_title_1: "Teléfono/WhatsApp:",
    accordion_title_2: "Correo electrónico:",
    accordion_title_3: "Disponibilidad:",
}

export { buttonText, labelText, nacionalityDefaultOptions, stateDefaultOptions, cityDefaultOptions, placeholderText, errorMessageText, altText, pageHomeText, pageLoginText, pageTherapistsText, modalPreferencesTherapistText };
